// ---------------------------------------------------------------------------
// Class–Subject Mapping – Feature metadata (follows project convention)
// ---------------------------------------------------------------------------
import { RectangleGroupIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const ClassSubjectMappingFeature: FeatureMetadata = {
  id: "classSubjectMapping",
  moduleName: "academics",

  navigation: {
    label: "Subject Mapping",
    path: "/class-subject-mapping",
    icon: RectangleGroupIcon,
    order: 5,
  },

  route: {
    path: "/class-subject-mapping",
    element: lazy(() => import("./pages/ClassSubjectMappingPage")),
  },

  permissions: {
    view: "Academics.ClassSubjectMapping.view",
    create: "Academics.ClassSubjectMapping.create",
    edit: "Academics.ClassSubjectMapping.edit",
    delete: "Academics.ClassSubjectMapping.delete",
  },

  readiness: "live",
};
